import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import cn from '../../utils/cn';

function Pagination({ data, onChangePage }) {
    const { cpp, page, pages, showing, total = 0 } = data || {};
    const [searchParams] = useSearchParams();
    const cuPageNumber = searchParams.get('page') || 1;

    useEffect(() => {
        const handleSetPage = () => {
            onChangePage(1);
        };
        if (cuPageNumber > pages?.[pages.length - 1]) {
            handleSetPage();
        }
    }, [cuPageNumber, pages, onChangePage]);

    if (total === 0) {
        return null;
    }
    return (
        <div className={cn('pagination mt-5 w-full h-12.5 flex justify-between items-center')}>
            <div className="text-base text-primary-700">
                Showing {showing?.[0]} to {showing?.[1]} of <b>{total}</b> entries
            </div>
            <div className="item_list flex gap-[5px] *:bg-primary-100 *:size-12.5 *:rounded-10 font-medium">
                {total > cpp &&
                    pages?.map((pageNumber) => {
                        if (pageNumber.toString().includes('-')) {
                            return (
                                <button
                                    type="button"
                                    key={pageNumber}
                                    className="flex justify-center items-center pointer-events-none !cursor-default focus:outline-1 focus:outline focus:outline-primary-700"
                                >
                                    ...
                                </button>
                            );
                        }
                        return (
                            <button
                                type="button"
                                key={pageNumber}
                                onClick={() => onChangePage(pageNumber)}
                                className={cn(
                                    'focus:outline-1 focus:outline focus:outline-primary-700  cursor-pointer',
                                    {
                                        '!bg-secondary text-white pointer-events-none cursor-default':
                                            page === pageNumber
                                    }
                                )}
                            >
                                {pageNumber}
                            </button>
                        );
                    })}
            </div>
        </div>
    );
}

export default Pagination;
